import { useTranslation } from "react-i18next";
import { useCreateInvoice } from "@/api/invoice";
import { Modal } from "@/components/ui/customs/modal";
import { UploadInvoice } from "../uploadInvoice";

type LitigeModalProps = {
  handleClose: () => void;
  isOpen: boolean;
};

export const LitigeModal = ({ handleClose, isOpen }: LitigeModalProps) => {
  const { t } = useTranslation("boClients");
  const { mutateAsync: createLitige } = useCreateInvoice();

  const handleUpload = async (key: string) => {
    await createLitige({
      invoiceKey: key,
      amountToBill: 0,
      totalTva: 0,
      totalHT: 0,
    });
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title={t("invoicesLitigeModal.title")}
      size="md"
      dismissible
      contentClassName="xl:max-w-[600px]"
    >
      <div className="flex w-full flex-col items-center gap-3">
        <p className="w-full text-center font-medium text-gray-600">
          {t("invoicesLitigeModal.description")}
        </p>
        <UploadInvoice handleUpload={handleUpload} />
      </div>
    </Modal>
  );
};
